module.exports = __webpack_public_path__ + "static/img/dokumenty01ok.c7c24f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/frontpage/dokumenty01ok.jpg
// module id = ZzzU
// module chunks = 1